import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import "./MedicalDisclaimer.css";
import * as http from "../../../../utils/http";
import * as translator from "../../../../utils/translator";
import Questionnaire from "../../../Questionnaire/Questionnaire";
import Significance from "../../../Questionnaire/components/Significance/Significance";
import { MainTracker } from "../../../../PixelTrackers/MainTracker";
import { useCartContext } from "../../../../customHooks/useCart";
import { trackStartReorderFlow } from "../../ReorderTrackingManager";
import { getPreselectedReorderPrice } from "../../reorderPrices";

type QuestionnaireSettingsType = {
  show: boolean;
  prefill: boolean;
};

const MedicalDisclaimer = () => {
  const navigate = useNavigate();
  const { reorderData, language, country, orderHashID, setHeaderStep, wlReorderVariant } = useOutletContext<any>();
  const { saveCart } = useCartContext();
  const [questionnaireSettings, setQuestionnaireSettings] = useState<QuestionnaireSettingsType>({
    show: false,
    prefill: false,
  });
  const [searchParamas] = useSearchParams();



  useEffect(() => {
    setHeaderStep("Questionnaire");
    window.eventsTracking.track({e: "Medical-change---Reorder"});
    trackStartReorderFlow(reorderData.trackingContext, getPreselectedReorderPrice(reorderData, country, wlReorderVariant), wlReorderVariant);
  }, [])


  const navigateToChooseTreatment = () => {
    const newSearchParams = searchParamas.toString()
    // Cannabis uses the live-stock-aware isAvailableForReorder flag; non-cannabis
    // has isAvailableForReorder always true, so fall back to the static inStock flag.
    const someProductsAreAvailableForReorder = reorderData.orderProductItems.some((item:any ) => item.isAvailableForReorder && (item.is_cannabis || item.inStock));
    if (someProductsAreAvailableForReorder) {
      navigate({ pathname: `/reorder/${orderHashID}/${country}/${language}/choose_treatment/`, search: `?${newSearchParams.toString()}`});
    } else {
      navigate({ pathname: `/select_treatment/${country}/${language}/${reorderData.catalogMention}`, search: `?${newSearchParams.toString()}`});
    }
  };

  const onSubmit = () => {
    // Only if health status didn't change (user pressed NO)

    //Since we need to create a cart like a normal flow, this block uses that same post of the questionnaire, just passing the previous's order's questionnaire in the body.
    http
      .postMultiPartsToServer(`questionnaire/${country}/${language}/${reorderData.catalogMention}?${searchParamas.toString()}`, {
        questionnaire: JSON.parse(reorderData.rawQuestionnaire),
        mention: reorderData.catalogMention,
        isBlocking: false,
        country: country,
        language: language,
        allowOnlyPrescription: false,
        isExpressReorder:true,
        reorderFromOrderHashID: orderHashID,
        customerVerificationRequired: searchParamas.get("cv") === 'true'


      }, [], [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.CART_ORDER])
      .then((response) => {
        saveCart({
            id: response.data.cartID,
            token: response.data.cartToken,
            mention: reorderData.catalogMention,
            mixpanel_title: response.data.catalog.mixpanel_title,
            products: [],
            timekitBooking: null,
            customer_verification_type: response.data.customerVerificationType,
            should_id_verify: response.data.shouldIDVerify
        });

        navigateToChooseTreatment();
      })
      .catch((err) => {
        window.clientLogger.error("error postToServer MedicalDisclaimerPage: ", err);
      });
  };

  if (questionnaireSettings.show) {
    return (
      <div className="reorder-questionnaire-container">


        {/* We want to show the significance that tells that customer that he can edit only if the questionnaire is prefilled */}
        {questionnaireSettings.prefill ? 
          <Significance 
          id={"reorder-questionnaire-significance"}
          dangerSignificancesRefsDispatch={null} 
          parentID={null} 
          showIcon 
          level={"success"} 
          fontWeight={400}
          fontSize={'16px'} 
          text={translator.translate(language, "reorder", "MedicalDisclaimer/questionnaire_significance")}
          />
          :
          null
        }
        
        <Questionnaire
          prefilledQuestionnaire={questionnaireSettings.prefill ? reorderData.prefilledQuestionnaire : null}
          overrideQuestionnaireParams={{ language, country, optionalCategory: reorderData.catalogMention }}
          navigationOverride={navigateToChooseTreatment}
          hideHeaderAndLogin={true}
          disableSkipQuestionnaireModal={true}
          enableSaveAnswers={true}
        />
      </div>
    );

  } else {
    return (
      <div className="medical-disclaimer-container">
        <p>{translator.translate(language, "reorder", "MedicalDisclaimer/order_ready")}</p>
        <h3>{translator.translate(language, "reorder", "MedicalDisclaimer/health_status_changed")}</h3>


        {/* questionnaire hasn't changed button (NO)*/}
        <button id="medical-disclaimer-no-button" onClick={() => onSubmit()}>
          {translator.translate(language, "reorder", "MedicalDisclaimer/no")}
        </button>

        {/* questionnaire has changed button (YES)*/}
        <button
          id="medical-disclaimer-yes-button"
          onClick={() => {
            //mp event
            MainTracker.track("pv","View-previous-questionnaire---Reorder");
            setQuestionnaireSettings((current) => ({ ...current, show: true, prefill: false }))}
          }>

          {translator.translate(language, "reorder", "MedicalDisclaimer/yes")}
        </button>


        {/* preview my old questionnaire (will prefill questionnaire) */}
        <span
          onClick={() => setQuestionnaireSettings((current) => ({ ...current, show: true, prefill: true }))}
          className="view-previous-questionnaire-link">
          {translator.translate(language, "reorder", "MedicalDisclaimer/view_prev_questionnaire")}
        </span>
      </div>
    );
  }
};

export default MedicalDisclaimer;
